import type {MotionProps} from '../types';
import * as tokens from '../tokens';

export const RECIPES = {
  overlay: {
    initial: {scale: tokens.scale.enter, opacity: 0},
    animate: {
      scale: tokens.scale.fullsize,
      opacity: 1,
      transition: {duration: tokens.duration.short, ease: tokens.easing.enter},
    },
    exit: {
      scale: tokens.scale.enter,
      opacity: 0,
      transition: {duration: tokens.duration.long, ease: tokens.easing.default},
    },
  },
  fade: {
    initial: {opacity: 0},
    animate: {
      opacity: 1,
      transition: {
        duration: tokens.duration.default,
        ease: tokens.easing.enter,
      },
    },
    exit: {
      opacity: 0,
      transition: {duration: tokens.duration.default, ease: tokens.easing.exit},
    },
  },
  scale: {
    initial: {scale: tokens.scale.enter, opacity: 0},
    animate: {
      scale: tokens.scale.fullsize,
      opacity: 1,
      transition: {
        duration: tokens.duration.default,
        ease: tokens.easing.enter,
      },
    },
    exit: {
      scale: tokens.scale.enter,
      opacity: 0,
      transition: {
        duration: tokens.duration.short,
        ease: tokens.easing.exit,
      },
    },
  },
  slideUp: {
    initial: {y: tokens.translate.regular, opacity: 0},
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        duration: tokens.duration.default,
        ease: tokens.easing.enter,
      },
    },
    exit: {
      y: -1 * tokens.translate.regular,
      opacity: 0,
      transition: {duration: tokens.duration.default, ease: tokens.easing.exit},
    },
  },
  slideDown: {
    initial: {y: -1 * tokens.translate.regular, opacity: 0},
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        duration: tokens.duration.default,
        ease: tokens.easing.enter,
      },
    },
    exit: {
      y: tokens.translate.regular,
      opacity: 0,
      transition: {duration: tokens.duration.default, ease: tokens.easing.exit},
    },
  },
  spring: {
    animate: {transition: tokens.spring.gentle},
    exit: {transition: tokens.spring.gentle},
  },
} satisfies Record<string, MotionProps>;

export type RecipeName = keyof typeof RECIPES;
